/* global axios */
import ApiClient from '../ApiClient';

class ArticleAttachmentsAPI extends ApiClient {
  constructor() {
    super('portals', { accountScoped: true });
  }

  attachmentsUrl({ portalSlug, articleId }) {
    return `${this.url}/${portalSlug}/articles/${articleId}/attachments`;
  }

  list({ portalSlug, articleId }) {
    return axios.get(this.attachmentsUrl({ portalSlug, articleId }));
  }

  upload({ portalSlug, articleId, file, signal }) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(
      this.attachmentsUrl({ portalSlug, articleId }),
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        signal,
      }
    );
  }

  delete({ portalSlug, articleId, attachmentId }) {
    return axios.delete(
      `${this.attachmentsUrl({ portalSlug, articleId })}/${attachmentId}`
    );
  }
}

export default new ArticleAttachmentsAPI();
